import anime from 'animejs'

export default function animate(targets, props, duration, delay = 0) {
  anime({
    targets,
    ...props,
    duration,
    delay,
    easing: props.translateY ? 'spring(1, 100, 60, 0)' : 'easeOutQuad',
  })
}